import { PublicKey, Keypair, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ReferralProgram } from "../type";
import { deriveTokenVault, deriveStakingAuthority } from "../pda";

export interface IInitializeStakingParams {
  referralProgram: ReferralProgram;
  owner: PublicKey;
  tokenMint: PublicKey;
  stakingPenaltyFeeReceiver: PublicKey;
  staking: Keypair;
  payer: PublicKey;
  unstakeCooldownSeconds: BN;
  minStakingAmount: BN;
  immediateUnstakePenaltyBps: number;
}

export async function createInitializeStakingIx(
  params: IInitializeStakingParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    owner,
    tokenMint,
    stakingPenaltyFeeReceiver,
    staking,
    payer,
    unstakeCooldownSeconds,
    minStakingAmount,
    immediateUnstakePenaltyBps,
  } = params;

  return referralProgram.methods
    .initializeStaking({
      unstakeCooldownSeconds,
      minStakingAmount,
      immediateUnstakePenaltyBps,
      padding: Array(10).fill(new BN(0)),
    })
    .accountsPartial({
      staking: staking.publicKey,
      tokenVault: deriveTokenVault(
        staking.publicKey,
        referralProgram.programId,
      ),
      tokenMint,
      owner,
      stakingPenaltyFeeReceiver,
      payer,
      stakingAuthority: deriveStakingAuthority(referralProgram.programId),
    })
    .instruction();
}
